<template>
  <div id="kw-mobile-panel-menu" :style='computedStyles'>
    <slot />
  </div>
</template>

<script>
import { bodyOverflow } from '@/mixins';

export default {
  name: 'KwMobilePanelMenu',
  mixins: [bodyOverflow],
  props: {
    bgColor: {
      type: String,
      default: '#f2f4f5',
    },
  },
  computed: {
    computedStyles() {
      return `background-color: ${this.bgColor};`;
    },
  },
};
</script>

<style lang="scss">
  #kw-mobile-panel-menu {
    position: fixed;
    height: 100%;
    overflow-y: scroll;
    width: 100%;
    z-index: 10;
    -webkit-overflow-scrolling: touch;
    // transition: all .4s ease;
  }
</style>



// WEBPACK FOOTER //
// src/components/KwMobilePanelMenu.vue